<template>
  <div>
    <div v-if="missingPrereqs" class="unit-card__alert-bottom prereq">
      <span class="unit-card__alert-bottom-content" :id="`tooltip-prereq-alert-${code}`">
        Error with pre-requisite <i class="far fa-info-circle"></i>
      </span>
      <b-tooltip :target="`tooltip-prereq-alert-${code}`" triggers="hover" placement="right" noninteractive>
        You have either not selected the pre-requisite for this unit, or have a pre-requisite scheduled in an invalid teaching period. Please select edit plan
        to
        fix these errors.
      </b-tooltip>
    </div>

    <div v-if="missingOfferings" class="unit-card__alert-bottom prereq">
      <span class="unit-card__alert-bottom-content" :id="`tooltip-offering-alert-${code}`">
        Offering not available <i class="far fa-info-circle"></i>
      </span>
      <b-tooltip :target="`tooltip-offering-alert-${code}`" triggers="hover" placement="right" noninteractive>
        The unit you have selected does not have any valid offerings.
      </b-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    unit: {
      type: Object,
      required: true
    },
    firstLevelTitle: {
      type: String,
      required: true
    },
    code: {
      type: String,
      required: true
    }
  },
  computed: {
    missingPrereqs() {
      return this.unit?.errors?.includes('PREREQUISITES')
    },
    missingOfferings() {
      return this.unit?.errors?.includes('OFFERINGS')
    }
  }
}
</script>
